import type { AnswerState } from '@repo/contracts/cardfinder/funnel/types';
import { getBranchForPrimaryGoal } from '../branch';
import type { BranchId } from '../constants';
import type { FlattenedFunnelConfig } from '../flattened/types';
import { ENTRY_STEP_ID } from '../flowConstants';
import type { FunnelConfig, HydratedBranchStep } from '../types';

function idToSlug(id: string): string {
  return id.replaceAll('_', '-');
}

function slugToId(id: string): string {
  return id.replaceAll('-', '_');
}

export function getStepId(slug: string): string {
  return slugToId(slug);
}

export function getBranchId(slug: string): BranchId {
  return slugToId(slug) as BranchId;
}

export function getStepSlug(step: { id: string }): string {
  return idToSlug(step.id);
}

export function getBranchSlug(branchId: BranchId): string {
  return idToSlug(branchId);
}

export function getBranchFromAnswers(config: FlattenedFunnelConfig, answers: AnswerState) {
  const primaryAnswer = answers[ENTRY_STEP_ID];
  if (typeof primaryAnswer !== 'string') return null;
  return getBranchForPrimaryGoal(config, primaryAnswer) ?? null;
}

export function getBranchStepBySlug(
  config: FunnelConfig,
  branchId: BranchId,
  slug: string,
): HydratedBranchStep | undefined {
  return config.branches[branchId]?.steps.find(s => getStepSlug(s.step) === slug);
}

export function getAllBranchSlugParams(
  config: FlattenedFunnelConfig,
): { branch: string; slug: string }[] {
  return (Object.keys(config.branches) as BranchId[]).flatMap(branchId =>
    config.branches[branchId].steps.map(({ step }) => ({
      branch: getBranchSlug(branchId),
      slug: getStepSlug(step),
    })),
  );
}

export function getBranchFirstStepHref(config: FlattenedFunnelConfig, branchId: BranchId): string {
  const { entry } = config.branches[branchId];
  return `/credit-cards/cardfinder/${getBranchSlug(branchId)}/${getStepSlug({ id: entry })}`;
}
